export class Controller {

    /** @ngInject */
    constructor($state) {
	this.$state=$state;
    }

    $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/user-directories.controller.js